import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {map} from "rxjs/operators";
import {ConvertPdfService} from "../services/convert-pdf.service";
import {CONVERT_TO_PDF_ACTION, ConvertToPdfAction} from "../actions/convert-pdf-actions"; // Votre service pour gérer la conversion

@Injectable()
export class ConvertToPdfEffects {
  constructor(
    private actions$: Actions,
    private pdfService: ConvertPdfService
  ) {}

  convertToPdf$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ConvertToPdfAction>(CONVERT_TO_PDF_ACTION),
        map((action) => {
          if (action.payload) {
            this.pdfService.convertToPdf(action.payload);
          }
        })
      ),
    { dispatch: false }
  );
}
